/******************************************************** Choose namimaatti ***************************************************/

$('.choose_vending_machine').click(function() {
    if(!$('#vending-machine').is('[readonly]')) {
        if($('#dropdown-content').is(':hidden')) {
            $('#dropdown-content').slideToggle()
            $('#dropdown-content').parent().addClass('open')
        }
    }
})

$('#dropdown-content .choice').on('click', function() {

    $('#dropdown-content').slideToggle(400, function() {
        $('#dropdown-content').parent().removeClass('open')
    })

    //check if cart items
    var match = document.cookie.match(new RegExp('(^| )' + 'woocommerce_items_in_cart' + '=([^;]+)'))

    if( match ) {
        let isExecuted = confirm("Jos vaihdat namimaattia, valitut tuotteet menetetään.")
        if(isExecuted == false) return;
        if(isExecuted == true) {
            document.cookie = 'clear_cart=1;  path=/'
        }
    }

    $('#vending-machine').val($(this).find('button').text())
    var namimaatti = $(this).find('button').attr('machine_id')
    if(namimaatti) {
        document.cookie = 'namimaatti=' + namimaatti + ';  path=/'
        var redirectURL = $(this).closest('.choose_vending_machine').data('redirect')
        if(redirectURL) {
            window.location.href = redirectURL + '?namimaatti=' + namimaatti
        } else {
            window.location = window.location.href.split("?")[0] 
        }
    }
})

$(document).mouseup(function(e) {
    if($('#dropdown-content').is(':visible')) {
        var container = $('.dropdown');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('#dropdown-content').slideToggle(400, function() {
                $('#dropdown-content').parent().removeClass('open')
            })
        }
    }
});

$('#vending-machine').keyup(function() {
    var input, filter, ul, li, a, i;
    input = document.getElementById("vending-machine");
    filter = input.value.toUpperCase();
    div = document.getElementById("dropdown-content");
    a = div.getElementsByClassName("choice");
    for (i = 0; i < a.length; i++) {
        txtValue = a[i].textContent || a[i].innerText;

        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            a[i].style.display = "";
        } else {
            a[i].style.display = "none";
        }
    }
})